"use strict";

/*
 * Original implementation: https://gitlab.com/vistaprint-org/channel-technology/kung-fu-pandas/gtm-gallery-design-for-retargeting
 */

const cookieUtil = require('../cookieUtil');
const galleryDesignIdCookieName = 'gallery_design_id';
const eventList = ['Product Viewed', 'Product List Viewed', 'Product Added', 'Checkout Step Viewed', 'Checkout Step Completed', 'Checkout Started', 'Gallery Design Engagement', 'Order Completed'];
const pageSectionList = ['Gallery', 'Studio', 'Configure - Recommendation', 'Configure - Option', 'Cart', 'Shipping', 'Payment Methods', 'Confirmation'];
function matchProductsAndTemplateId(products_ids, array_template_id) {
  const matchProductArray = [];
  products_ids.forEach(function (productId) {
    const templateArray = array_template_id?.reverse()?.find(templateId => !matchProductArray.includes(templateId) && templateId.toLowerCase().indexOf(productId.toLowerCase()) > -1);
    if (templateArray) {
      matchProductArray.push(templateArray);
    } else {
      matchProductArray.push(productId);
    }
  });
  return matchProductArray;
}
function combineProductsAndTemplateId(products_ids, evProductId, array_template_id) {
  return products_ids ? matchProductsAndTemplateId(products_ids, array_template_id) : evProductId;
}
function setGalleryDesign(event, evPageSection, evLabel, products_ids, cGalleryDesignId, evProductId) {
  let productIds = undefined;
  let array_template_id = undefined;
  if (cGalleryDesignId) {
    array_template_id = cGalleryDesignId.split(',');
  }
  if (eventList.includes(event)) {
    if (pageSectionList.includes(evPageSection)) {
      if (!products_ids) {
        // when single product id is present in event
        if (array_template_id | (evLabel === 'Gallery page view' && event === 'Product Viewed')) {
          productIds = combineProductsAndTemplateId(products_ids, evProductId, array_template_id);
        } else {
          productIds = matchProductsAndTemplateId([evProductId], array_template_id);
        }
      } else {
        // when multiple product ids are present in event
        productIds = array_template_id ? combineProductsAndTemplateId(products_ids, evProductId, array_template_id) : products_ids;
      }
    } else {
      // when pages are not the pageSectionList
      productIds = products_ids ? products_ids.slice(0, 3) : evProductId;
    }
  } else {
    // when event is not the eventList
    productIds = event === 'Gallery Impression' ? evProductId : undefined;
  }
  return productIds;
}
const productDesignMiddleware = _ref => {
  let {
    payload,
    next
  } = _ref;
  if (!payload || !payload.obj || !payload.obj.event) {
    next(payload);
    return;
  }
  payload.obj.properties = payload.obj.properties || {};
  const obj = payload.obj;
  const properties = obj.properties || {};
  try {
    let product_ids = undefined;
    if (properties.products && Array.isArray(properties.products)) {
      product_ids = properties.products.map(product => product.product_id);
    }
    const galleryDesignIdCookieValue = cookieUtil.getCookie(galleryDesignIdCookieName);
    let productsPlusDesigns = setGalleryDesign(obj.event, properties.pageSection, properties.label, product_ids, galleryDesignIdCookieValue, properties.product_id) || [];
    productsPlusDesigns = Array.isArray(productsPlusDesigns) ? productsPlusDesigns : [productsPlusDesigns];
    updateProperties(properties, productsPlusDesigns);
  } catch (e) {
    console.log(e);
  } finally {
    next(payload);
  }
};
function updateProperties(properties, productsPlusDesigns) {
  // masks specific logic
  if (properties.trackingTenant === 'masks' && properties.name) {
    // replace TM character
    properties.name = properties.name.replace(/[\u2122]/g, '');
  }
  if (properties.product_id && productsPlusDesigns.length > 0) {
    properties.product_id = productsPlusDesigns[0];
  }
  if (properties.products && productsPlusDesigns.length > 0) {
    properties.products = productsPlusDesigns.map(p => {
      return {
        product_id: p,
        quantity: 1
      };
    });
  }
  properties.content_ids = productsPlusDesigns;
  properties.contents = productsPlusDesigns.map(p => {
    return {
      id: p,
      quantity: 1
    };
  });
}
const getMiddlewareDefinitions = () => {
  return [{
    targetIntegration: 'Facebook Pixel',
    middlewares: [productDesignMiddleware]
  }];
};
module.exports = {
  getDestinationMiddlewares: getMiddlewareDefinitions
};